module.exports = __webpack_public_path__ + "static/img/sec_hover.7e8d5408.gif";